{
  "intro": "Серверы одной группы «spread» работают на разных физических хостах: отказ одного хоста затронет не больше одного из них. Удобно для реплик базы данных и нескольких копий сервиса. Группы бесплатны.",
  "empty": "Групп размещения пока нет",
  "emptyLead": "Создайте группу и добавьте в неё серверы, которые не должны оказаться на одном хосте — например, основной и резервный.",
  "create": "Создать группу",
  "createLead": "Группа типа «spread»: серверы разносятся по разным хостам.",
  "createSubmit": "Создать группу",
  "created": "Группа {{name}} создана",
  "name": "Название",
  "nameHint": "Например, по сервису: web, db.",
  "kind": "Тип",
  "spread": "Spread — на разных хостах",
  "servers": "Серверы",
  "count": "{{count}} из {{max}}",
  "noServers": "Пока пусто",
  "free": "Бесплатно",
  "createdAt": "Создана",
  "labels": "Метки",
  "labelsHint": "По одной на строку: ключ=значение.",
  "labelsInvalid": "Строка {{line}}: ключ и значение — до 63 латинских букв, цифр, точек, дефисов и подчёркиваний.",
  "add": "Добавить сервер",
  "addTitle": "Добавить сервер в {{name}}",
  "addLead": "Сервер должен быть выключен: Hetzner переносит его на подходящий хост при следующем включении. В группе — до {{max}} серверов, у сервера — одна группа.",
  "adding": "Добавляем {{server}} в {{name}}",
  "remove": "Убрать сервер",
  "removeTitle": "Убрать сервер из {{name}}",
  "removeLead": "Сервер останется работать как есть; он просто перестанет учитываться при размещении группы.",
  "removing": "Убираем {{server}} из {{name}}",
  "server": "Сервер",
  "chooseServer": "Выберите сервер",
  "edit": "Имя и метки",
  "editTitle": "Группа {{name}}",
  "delete": "Удалить",
  "deleteTitle": "Удалить группу {{name}}?",
  "deleteLead": "Серверов в группе нет, удаление ничего не меняет у серверов.",
  "deleted": "Группа {{name}} удалена",
  "why": {
    "running": "не выключен",
    "inGroup": "в группе {{group}}",
    "here": "уже в этой группе",
    "full": "В группе уже {{max}} серверов — больше нельзя.",
    "empty": "В группе нет серверов.",
    "notEmpty": "Сначала уберите из группы все серверы."
  },
  "serverFact": "Группа размещения",
  "serverNone": "Нет",
  "price": "В месяц"
}
